import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import NavigationMenuList from 'components/navigation_menu_list/navigation_menu_list'
import navigationMenuContentTypes from 'helpers/enums/navigationMenuContentTypes'
import navigationMenuHelpItemTypes from 'helpers/enums/navigationMenuHelpItemTypes'
import HelpCenterIcon from 'assets/views/navigation_menu/main/help_icon.svg'
import TeacherResourcesIcon from 'assets/views/navigation_menu/help/teacher_resources_icon.svg'
import WhatsNewIcon from 'assets/views/navigation_menu/help/whats_new_icon.svg'
import PersonalizedNewsIcon from 'assets/views/navigation_menu/help/personalized_news_icon.svg'
import ContactUsIcon from 'assets/views/navigation_menu/help/contact_icon.svg'
import backIcon from 'assets/views/navigation_menu/back_icon.svg'
import OnboardingGuideIcon from 'assets/views/navigation_menu/help/onboarding_guide_icon.svg'

import styles from './view.scss'

class NavigationMenuHelp extends PureComponent {

	constructor(props) {
		super(props)

		this.items = [
			{
				id: navigationMenuHelpItemTypes.HELP_CENTER,
				icon: HelpCenterIcon,
				label: localize('navigationMenu_helpCenter_label2'),
				isExtended: false,
			},
			{
				id: navigationMenuHelpItemTypes.ONBOARDING_GUIDE,
				icon: OnboardingGuideIcon,
				label: localize('onboardingGuide_navstack_button'),
				isExtended: false,
			},
			{
				id: navigationMenuHelpItemTypes.TEACHER_RESOURCES,
				icon: TeacherResourcesIcon,
				label: localize('navigationMenu_teacherResources_label'),
				isExtended: false,
			},
			{
				id: navigationMenuHelpItemTypes.WHATS_NEW,
				icon: WhatsNewIcon,
				label: localize('navigationMenu_nearpodBlog_label'),
				isExtended: false,
			},
			{
				id: navigationMenuHelpItemTypes.PERSONALIZED_NEWS,
				icon: PersonalizedNewsIcon,
				label: localize('navigationMenu_personalizedNews_label'),
				isExtended: false,
			},
			{
				id: navigationMenuHelpItemTypes.CONTACT_US,
				icon: ContactUsIcon,
				label: localize('navigationMenu_contactUs_label'),
				isExtended: false,
			},
		].filter(item =>
			item.id !== navigationMenuHelpItemTypes.PERSONALIZED_NEWS ||
			this.props.shouldAddPeronsalizedNews
		).filter(item =>
			item.id !== navigationMenuHelpItemTypes.ONBOARDING_GUIDE ||
			this.props.shouldShowOnboardingGuideButton
		)
	}

	navigateBack = () => this.props.navigateTo(navigationMenuContentTypes.MAIN)

	onSelect = id => this.props.handleNavigationSelected(id)

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='header' onClick={this.navigateBack}>
					<Isvg styleName='header-back' src={backIcon} cacheGetRequests={true} />
					<h1 styleName='header-title'>{localize('navigationMenu_help_label2')}</h1>
				</div>
				<NavigationMenuList
					items={this.items}
					onSelect={this.onSelect}
				/>
			</div>
		)
	}
}

NavigationMenuHelp.propTypes = {
	navigateTo: PropTypes.func,
	handleNavigationSelected: PropTypes.func,
	shouldAddPeronsalizedNews: PropTypes.bool,
	shouldShowOnboardingGuideButton: PropTypes.bool,
}

NavigationMenuHelp.defaultProps = {
	navigateTo: () => {},
	handleNavigationSelected: () => {},
	shouldAddPeronsalizedNews: false,
	shouldShowOnboardingGuideButton: false,
}

export default CSSModules(
	NavigationMenuHelp, styles, {allowMultiple: true})
